import styles from '../cssModules/index.module.css';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
// import { Dropdown, Form } from 'react-bootstrap';


export function BandRepeat({ prod, setProdInfo, loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    let jToken = localStorage.getItem('token');

    const color = ['green', 'red', 'blue', 'grey', 'white', 'black', 'brown', 'pink', 'orange', 'yellow', 'purple', 'gold', 'silver',
        'turquoise', 'whitesmoke'];

    const design = ['Charm'];

    const material = ['Precious Metal', 'Pearl', 'Plastic', 'Bamboo', 'Ceramic', 'Enamel', 'Fabric', 'Leather', 'Resin', 'Rubber',
        'Shell', 'Wood', 'Mother of Pearl', 'Other'
    ];

    const materialFeature = ['Lightweight', 'Hypoallergenic', 'Natural', 'Biodegradable', 'Organic', 'Recycled Materials', 'Vegan', 'Other'];

    const stone = ['Cubic Zirconia', 'Pearl', 'Diamond', 'Agate', 'Alexandrite', 'Amber', 'American Diamond', 'Amethyst', 'Glass', 'Aquamarine',
        'Crystal', 'Emerald', 'Fluorite', 'Iolite', 'Jade', 'Opal', 'Peridot', 'Quartz', 'Rhinestone', 'Ruby', 'Sapphire', 'Shell',
        'Topaz', 'Tourmaline', 'Other', 'None'
    ]

    const cut = ['Ideal', 'Very good', 'Good', 'Fair'];

    const stoneShape = ['Round', 'Heart', 'Pear', 'Asscher', 'Baguette', 'Bullet', 'Cushion', 'Emerald Cut', 'Half Moon',
        'Marquise', 'Oval', 'Princess Cut', 'Rectangular', 'Square', 'Trapezoid', 'Other'
    ];

    const userSegment = ['Men', 'Women', 'Unisex'];

    const occesion = ['Casual', 'Formal', 'Anniversary', 'Wedding', 'Birthday', 'Baby Shower', "Valentine's Day", 'Christmas']

    
    const stock = ['In stock', 'Out of stock']

    const weightCat = ['Category 1 (upto 500 gm)', 'Category 2 (between 500 gm to 1 kg)', 'Category 3 (between 1 to 2 kg)']


    const [pht1, setpht1] = useState();
    const [pht2, setpht2] = useState();
    const [pht3, setpht3] = useState();
    const [pht4, setpht4] = useState();
    const [pht5, setpht5] = useState();

    const navigate = useNavigate();

    function checkFileSize(file) {
        if (file.size > 500000) {
            alert('File size should be less than 500 KB');
            return false;
        } else {
            return true;
        }
    }

    const ph1Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht1(e.target.files[0]);
    }
    const ph2Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht2(e.target.files[0]);
    }
    const ph3Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht3(e.target.files[0]);
    }
    const ph4Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht4(e.target.files[0]);
    }
    const ph5Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht5(e.target.files[0]);
    }

    function changeWeightCat(value) {
        switch (true) {
            case (value === 'Category 1 (upto 500 gm)'):
                return 1;
            case (value === 'Category 2 (between 500 gm to 1 kg)'):
                return 2;
            default:
                return 3;
        }
    }

    function changeWeightCatReverse(value) {
        switch (true) {
            case (Number(value) === 1):
                return 'Category 1 (upto 500 gm)';
            case ((Number(value)) === 2):
                return 'Category 2 (between 500 gm to 1 kg)';
            default:
                return 'Category 3 (between 1 to 2 kg)';
        }
    }

    const handleSubmit = async (e, msg) => {
        try {
            e.preventDefault();
            const images = [pht1, pht2, pht3, pht4, pht5];
            if (!(pht1 && pht2 && pht3 && pht4 && pht5)) return;

            const formData = new FormData();
            images.forEach((image) => {
                formData.append('images', image);
            });

            formData.append('product', JSON.stringify(prod));


            const response = await fetch(`${apiURL}/api/upload/image`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${jToken}` },
                body: formData,
                credentials: 'include'
            })

            if (response.status === 500) {
                throw new Error('Error while uploading product!');
            } else {

                if (response.status === 200) {
                    if (msg === 'repeat') {
                        alert('Product has been listed successfully!');
                        window.location.reload();
                    } else {
                        alert('Product has been listed successfully!');
                        window.location.reload();
                    }
                } else {
                    navigate('/');
                }
            }
        } catch (error) {
            console.log(error.message);
            await loginStatus();
            navigate('/login');
        }
    };

    return (
        <>
            {(<div className={`${styles.sellerUploadmainDiv}`}>
                <form id='uploadForm' onSubmit={(e) => handleSubmit(e, 'form')} className={`${styles.sellerUploadForm}`}>
                    <div className={`${styles.sellerUploadDiv}`}>
                        <div className={`${styles.sellerUploadPhotoSecDiv}`}>
                            <div className={`${styles.sellerUploadPhotoInput}`}>

                                <label for='ph1'>
                                    Choose photo 1
                                </label>
                                <input id='ph1' type='file' onChange={ph1Upload} required={true} accept='image/*' />
                            </div>
                            <div className={`${styles.sellerUploadPhotoInput}`}>

                                <label for='ph2'>
                                    Choose photo 2
                                </label>
                                <input id='ph2' type='file' onChange={ph2Upload} required={true} accept='image/*' />
                            </div>
                            <div className={`${styles.sellerUploadPhotoInput}`}>

                                <label for='ph3'>
                                    Choose photo 3
                                </label>
                                <input id='ph3' type='file' onChange={ph3Upload} required={true} accept='image/*' />
                            </div>
                            <div className={`${styles.sellerUploadPhotoInput}`}>

                                <label for='ph4'>
                                    Choose photo 4
                                </label>
                                <input id='ph4' type='file' onChange={ph4Upload} required={true} accept='image/*' />
                            </div>
                            <div className={`${styles.sellerUploadPhotoInput}`}>

                                <label for='ph5'>
                                    Choose photo 5
                                </label>
                                <input id='ph5' type='file' onChange={ph5Upload} required={true} accept='image/*' />
                            </div>
                        </div>
                        <div className={`${styles.selleruploadFormDiv}`}>



                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='color'>
                                    Color
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='color' name='color' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.color} selected >{prod.color}</option>
                                    {color.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='material'>
                                    Material
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='material' name='material' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.material} selected >{prod.material}</option>
                                    {material.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='stone'>
                                    Stone
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='stone' name='stone' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.stone} selected >{prod.stone}</option>
                                    {stone.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='userSegment'>
                                    User segment
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='userSegment' name='userSegment' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.userSegment} selected >{prod.userSegment}</option>
                                    {userSegment.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='materialFeature'>
                                    Material Feature
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='materialFeature' name='materialFeature' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.materialfeature} selected >{prod.materialfeature}</option>
                                    {materialFeature.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='cut'>
                                    Cut
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='cut' name='cut' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.cut} selected >{prod.cut}</option>
                                    {cut.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='stoneShape'>
                                    Stone Shape
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='stoneShape' name='stoneShape' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.stoneshape} selected >{prod.stoneshape}</option>
                                    {stoneShape.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>

                                <label for='design'>
                                    Design
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='design' required name='design' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                    <option value={prod.design} selected >{prod.design}</option>
                                    {design.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='occesion'>
                                    occesion
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='occesion' name='occesion' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.occesion} selected >{prod.occesion}</option>
                                    {occesion.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>


                            <div className={`${styles.sellerUploadLabelDiv}`}>

                                <label for='stock'>
                                    Stock
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='stock' required name='active' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                    <option value={prod.active} selected hidden>{prod.active}</option>
                                    {stock.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>

                                <label for='weightCat'>
                                    Weight category (Courier ready)
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='weightCat' required name='weightCat' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                    <option value={prod.weightCat} selected >{changeWeightCatReverse(prod.weightCat)}</option>
                                    {weightCat.map(item => {
                                        return (
                                            <>
                                                <option value={changeWeightCat(item)}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='name'>
                                    Name
                                </label>
                                <input className={`${styles.sellerUploadSelect}`} id='name'
                                    onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                    required
                                    defaultValue={prod.name}
                                    type='text' placeholder="Name of the product" name='name' />
                            </div>
                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='oldPrice'>
                                    Price
                                </label>
                                <input className={`${styles.sellerUploadSelect}`}
                                    id='oldPrice'
                                    onChange={(e) =>
                                        setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                    required={true}
                                    type='number'
                                    defaultValue={prod.oldPrice}
                                    placeholder="price"
                                    name='oldPrice' />
                            </div>
                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='currentPrice'>
                                    Discount Price
                                </label>
                                <input className={`${styles.sellerUploadSelect}`} id='currentPrice'
                                    onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                    required={true} type='number' placeholder="This price will be highlighted"
                                    defaultValue={prod.currentPrice}
                                    name='currentPrice' />
                            </div>
                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='stock'>
                                    In stock
                                </label>
                                <input className={`${styles.sellerUploadSelect}`} id='stock'
                                    onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                    required={true} type='number'
                                    defaultValue={prod.stock}
                                    placeholder="Total stock available" name='stock' />
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='sku'>
                                    Stock keeping unit
                                </label>
                                <input className={`${styles.sellerUploadSelect}`} id='sku' defaultValue={prod.sku}
                                    onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                    required={true}
                                    type='text'
                                    placeholder="SKU"
                                    name='sku' />
                            </div>
                        </div>
                    </div>
                    <input type="submit" value='UPLOAD' className={`${styles.sellerUploadBtn}`} />
                    <button className={`${styles.uploadRepeat}`}
                        onClick={(e) => { handleSubmit(e, 'repeat') }}>Upload & Repeat</button>
                </form >
            </div >)
            }
        </>
    )
}